import { CommonModule } from '@angular/common';
import { Component, input, inject, signal, AfterViewInit } from '@angular/core';

import { TimespanMsPipe, TimespanShortPipe } from '../shared/time-span.pipe';

import { TelemetryService } from './telemetry.service';
import { BarGaugeComponent } from './bar-gauge/bar-gauge.component';
import { ITelemetryData } from './ITelemetryData';
import { VisibilitiesService } from '../shared/visibilities.service';

@Component({
	selector: 'vb-lxp-timing-tower-drawer',
	standalone: true,
	imports: [CommonModule, TimespanMsPipe, TimespanShortPipe, BarGaugeComponent],
	templateUrl: './timing-tower-drawer.component.html',
	styleUrl: './timing-tower-drawer.component.css',
})
export class TimingTowerDrawerComponent implements AfterViewInit {
	public team = input<any>(null);
	public isOpen = input(false);

	public telemetry = signal<ITelemetryData | null>(null);

	public telemetryService = inject(TelemetryService);
	public visibilitiesService = inject(VisibilitiesService);

	public index = 0;

	constructor() {}

	ngAfterViewInit(): void {
		if (this.visibilitiesService.controlVisibilities().showTelemetry) {
			this.telemetryService.telemetryData$.subscribe((data) => {
				const telem = data.find((d) => d.scoring.number === this.team().number);
				this.telemetry.set(telem);
			});
		}
	}

	public getBestSector(team: any): { number: number; time: number } | null {
		const bestSectors = team?.participantDetails?.bestSectors;
		if (!bestSectors) {
			return null;
		}

		const sectorCandidates = [1, 2, 3]
			.map((number) => {
				const time = bestSectors?.[number]?.time;
				return typeof time === 'number' ? { number, time } : null;
			})
			.filter((sector): sector is { number: number; time: number } => !!sector);

		if (sectorCandidates.length === 0) {
			return null;
		}

		return sectorCandidates.reduce((best, sector) => (sector.time < best.time ? sector : best));
	}

	public formatSpeed(speed: number) {
		return Math.round(speed * 0.621371) + 'mph';
	}

	public formatRpm(rpm: number) {
		return Math.round(rpm);
	}
}
